module.exports = __webpack_public_path__ + "static/media/code.74248ebc.png";